import React from 'react';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';

export function ButtonsRenderer({ componentMap, buttons, isTed7485Recipe = false, isPrivatePartyListing = false }) {
  if (!buttons.length) return null;

  const buttonsToRender = buttons.slice(0, 2);

  const COLUMN_SIZES = { 1: [12], 2: isTed7485Recipe && isPrivatePartyListing ? [6, 6] : [4, 8] };
  const colSizes = COLUMN_SIZES[buttonsToRender.length];

  return buttonsToRender.map(({ type, payload }, index) => {
    const renderButton = componentMap[type];

    if (!renderButton) return null;

    return (
      <Col key={type} xs={colSizes[index]}>
        {renderButton(payload)}
      </Col>
    );
  });
}

ButtonsRenderer.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, payload: PropTypes.shape({}) })).isRequired,
  componentMap: PropTypes.shape({}).isRequired,
  isTed7485Recipe: PropTypes.bool,
  isPrivatePartyListing: PropTypes.bool,
};
